import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["title", "content", "onOk", "onCancel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Modal } from 'antd';
import { NO_OP } from '../constants/Constants';
const {
  confirm
} = Modal;
export const showConfirm = _ref => {
  let {
      title,
      content,
      onOk = NO_OP,
      onCancel = NO_OP
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  confirm(_objectSpread({
    title,
    content,
    onOk: onOk,
    onCancel: onCancel
  }, rest));
};